import React, { useEffect } from 'react';

export default function ConfirmModal({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', onConfirm, onCancel }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  return (
    <div style={styles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
      <div style={styles.modal}>
        <p style={styles.title}>{title}</p>
        <p style={styles.message}>{message}</p>
        <div style={styles.actions}>
          <button type="button" style={styles.cancelBtn} onClick={onCancel}>{cancelLabel}</button>
          <button type="button" style={styles.confirmBtn} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(10, 15, 30, 0.92)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modal: {
    position: 'relative',
    background: 'linear-gradient(145deg, rgba(15,22,41,0.95) 0%, rgba(10,15,30,0.98) 100%)',
    border: '1px solid #1E2D4A',
    borderRadius: '16px',
    padding: '32px 32px 28px',
    width: '100%',
    maxWidth: '360px',
    boxShadow: '0 24px 80px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.04)',
  },
  title: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#E8EEFF',
    marginBottom: '8px',
    fontFamily: "'Syne', sans-serif",
    letterSpacing: '0.02em',
  },
  message: {
    fontSize: '13px',
    color: '#6B7FA8',
    marginBottom: '24px',
    lineHeight: 1.55,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  cancelBtn: {
    background: 'transparent',
    border: '1px solid #1E2D4A',
    borderRadius: '8px',
    color: '#6B7FA8',
    padding: '9px 18px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: "'Outfit', system-ui, sans-serif",
  },
  confirmBtn: {
    padding: '9px 18px',
    borderRadius: '8px',
    border: 'none',
    background: 'linear-gradient(135deg, #2E6AFF 0%, #1a4fd6 100%)',
    color: '#fff',
    fontFamily: "'Outfit', system-ui, sans-serif",
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '0.02em',
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(46, 106, 255, 0.35)',
  },
};
